export default { sha: '833264e8990a65ad9d301dae28db51b9ee06373f', buildNumber: 'undefined' }
